import { useEffect, useRef } from 'react';
import { ShieldAlertIcon } from 'lucide-react';
import { useTenantEntity } from './tenant-entity-provider';
import { useAccessClock, remainingAccess } from './temporary-access';

export function ElevationBanner() {
  const access = useTenantEntity();
  const now = useAccessClock();
  const refreshed = useRef(new Set<string>());
  const active = access.activeElevations.filter(e => Date.parse(e.expiresAt) > now);
  useEffect(() => {
    const expired = access.activeElevations.filter(e => Date.parse(e.expiresAt) <= now && !refreshed.current.has(e.id));
    if (expired.length) {
      expired.forEach(e => refreshed.current.add(e.id));
      void access.refresh();
    }
  }, [now, access]);
  if (!active.length) return null;
  return <section aria-label="Temporary Security Elevation" className="shrink-0 border-b border-amber-300 bg-amber-50 px-4 py-2 text-sm text-amber-950 dark:border-amber-700 dark:bg-amber-950 dark:text-amber-100">
    <div className="flex items-center gap-2 font-semibold"><ShieldAlertIcon className="size-4" />Temporary Security Elevation</div>
    {active.map(e => <p key={e.id} className="mt-1">{e.roleName} · Expires {new Date(e.expiresAt).toLocaleString()} · {remainingAccess(e.expiresAt, now)}</p>)}
  </section>;
}
